<template>
  <li
    :class="[
      { 'timeline-inverted': inverted },
      { 'timeline-simple': !inverted }
    ]"
  >
    <slot name="badge">
      <div class="timeline-badge" :class="badgeType">
        <md-icon>{{ badgeIcon }}</md-icon>
      </div>
    </slot>
    <div class="timeline-panel">
      <div class="timeline-body">
        <h3>
          {{ formatStartDate(data.startDate) }} -
          {{ formatStopDate(data.stopDate) }}
          <md-button
            class="md-success md-sm"
            @click.native="handleEdit(getIds)"
          >
            Bewerken
          </md-button>
          <md-button
            class="md-danger md-sm"
            @click.native="handleDelete(getIds)"
          >
            Verwijderen
          </md-button>
        </h3>
      </div>
      <div class="md-layout">
        <div
          class="md-layout-item md-xsmall-size-40"
          v-for="(dayOfTheWeek, dayOfTheWeekIndex) in {
            1: 'Maandag',
            2: 'Dinsdag',
            3: 'Woensdag',
            4: 'Donderdag',
            5: 'Vrijdag',
            6: 'Zaterdag',
            7: 'Zondag'
          }"
          :value="dayOfTheWeek"
          :key="dayOfTheWeekIndex"
        >
          <md-card>
            <md-card-content>
              <div class="text-center">
                {{ dayOfTheWeek }}
                <br />
                <md-icon
                  class="material-icons"
                  :style="getStyleColorByDay(dayOfTheWeekIndex)"
                  :title="getAvailabilityLabelByDay(dayOfTheWeekIndex)"
                >
                  {{ getStyleIconByDay(dayOfTheWeekIndex) }}
                </md-icon>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <div class="md-layout" v-if="hasSubPeriods">
        <div class="md-layout-item md-xsmall-size">
          <time-line plain type="simple">
            <time-line-item-route-period
              inverted
              badge-type="primary"
              badge-icon="schedule"
              v-for="(period, index) in this.dataPeriods"
              :key="index"
              v-model="data.periods[index]"
              :data="period"
              :selectableAvailabilityTypes="selectableAvailabilityTypes"
            ></time-line-item-route-period>
          </time-line>
        </div>
      </div>
      <h6 v-if="$slots.footer">
        <slot name="footer"></slot>
      </h6>
    </div>
  </li>
</template>
<script>
import { TimeLine, TimeLineItemRoutePeriod } from "@/components";
import swal from "sweetalert2";
export default {
  name: "time-line-item-route-period",
  components: {
    TimeLine,
    TimeLineItemRoutePeriod
  },
  props: {
    inverted: Boolean,
    data: {
      type: Object,
      default: function() {
        return {
          id: "",
          route_id: "",
          startDate: null,
          stopDate: null,
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0,
          sunday: 0,
          periods: [],
          dayPeriods: []
        };
      }
    },
    selectableAvailabilityTypes: {
      type: Object,
      default: function() {
        return [];
      }
    },
    badgeType: {
      type: String,
      default: "success"
    },
    badgeIcon: {
      type: String,
      default: ""
    }
  },
  methods: {
    formatStartDate(date) {
      date = this.formatDate(date);

      if (typeof date === "string") {
        return date;
      }

      return "Geen start datum";
    },
    formatStopDate(date) {
      date = this.formatDate(date);

      if (typeof date === "string") {
        return date;
      }

      return "Geen stop datum";
    },
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    getStyleColorByDay: function(dayOfTheWeek) {
      for (let i in this.data.dayPeriods) {
        if (this.data.dayPeriods[i].dayOfTheWeek == dayOfTheWeek) {
          // return this.data.dayPeriods[i].availability;
          return (
            "color: " +
            this.selectableAvailabilityTypes[
              this.data.dayPeriods[i].availability
            ].color +
            " !important;"
          );
        }
      }

      return (
        "color: " + this.selectableAvailabilityTypes[9].color + " !important;"
      );
    },
    getStyleIconByDay: function(dayOfTheWeek) {
      for (let i in this.data.dayPeriods) {
        if (this.data.dayPeriods[i].dayOfTheWeek == dayOfTheWeek) {
          return this.selectableAvailabilityTypes[
            this.data.dayPeriods[i].availability
          ].icon;
        }
      }

      return this.selectableAvailabilityTypes[9].icon;
    },
    getAvailabilityLabelByDay: function(dayOfTheWeek) {
      for (let i in this.data.dayPeriods) {
        if (this.data.dayPeriods[i].dayOfTheWeek == dayOfTheWeek) {
          return this.selectableAvailabilityTypes[
            this.data.dayPeriods[i].availability
          ].label;
        }
      }

      return this.selectableAvailabilityTypes[9].label;
    },
    colorGreen: function(type) {
      if (type === 1) {
        return true;
      }

      return false;
    },
    handleEdit(periodIds) {
      this.$router.push(
        "/drivers/edit/" +
          this.getDriverId +
          "/availablePeriod/edit/" +
          periodIds.toString()
      );
    },
    handleDelete(periodIds) {
      swal
        .fire({
          title: "Weet u het zeker?",
          text:
            'De beschikbaarheid "' +
            this.formatStartDate(this.data.startDate) +
            " t/m " +
            this.formatStopDate(this.data.stopDate) +
            '" wordt uit het systeem verwijderd.',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Verwijderen",
          cancelButtonText: "Annuleren",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$emit("handleDelete", periodIds);
          }
        });
    },
    deleteRow(id) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  computed: {
    getIds: function() {
      let ids = [];

      for (var i in this.data.dayPeriods) {
        if (this.data.dayPeriods[i].id.length !== 36) {
          continue;
        }

        ids.push(this.data.dayPeriods[i].id);
      }

      return ids;
    },
    getDriverId: function() {
      for (var i in this.data.dayPeriods) {
        if (this.data.dayPeriods[i].driver_id.length !== 36) {
          continue;
        }

        return this.data.dayPeriods[i].driver_id;
      }

      return "";
    },
    hasSubPeriods: function() {
      return this.dataPeriods.length > 0;
    },
    dataPeriods: function() {
      return this.data.periods;

      var periods = [];

      for (var i in this.data.periods) {
        periods.push(this.data.periods[i]);
      }

      return periods;
    }
  }
};
</script>
<style>
.color-red {
  color: red !important;
}
.color-orange {
  color: orange !important;
}
.color-green {
  color: green !important;
}
</style>
